/**
 * UI-7.1 — the arithmetic of dragging one row of a list into another place.
 *
 * Kept apart from the pointer plumbing because this is the part that is wrong
 * quietly: an off-by-one drops the row next to where it was let go, and a list
 * written through instead of copied leaves React drawing the old order.
 */

/** The list with the row at `from` taken out and put back in at `to`. */
export function moveItem<T>(list: T[], from: number, to: number): T[] {
  if (from < 0 || to < 0 || from >= list.length || to >= list.length) return list;
  const next = [...list];
  const [row] = next.splice(from, 1);
  if (row === undefined) return list;
  next.splice(to, 0, row);
  return next;
}

/**
 * Which row the finger is over: where the drag started, plus however many whole
 * rows it has travelled since. Rounding rather than truncating is what makes
 * the list settle under the finger halfway through a row rather than a full row
 * late, and the clamp is what keeps a drag flung off the end at the end.
 */
export function indexAfterDrag(from: number, travelY: number, rowHeight: number, count: number): number {
  if (rowHeight <= 0) return from;
  const moved = from + Math.round(travelY / rowHeight);
  return Math.max(0, Math.min(count - 1, moved));
}
